import api from '@/core/api';
import HttpStatusError from '@/core/http-module/error/http-status-error';
import HttpResponse from '@/core/http-module/http-response';

export const uploadTrademarkImage = async (file: File, appReference: string, countryCode: string)=> {
    if (!file || !(file instanceof File) || file.size === 0) {
        return {error: 'Invalid file'};
    }

    const formData = new FormData();
    formData.append('file',file, file.name);
    formData.append('applicationRef', appReference);

    const response = await api.markImage.postImage(countryCode.toLowerCase(), formData);

    if(response instanceof HttpStatusError && response.status === 413) {
        return {error: 'File size exceeded'};
    }

    if (!(response instanceof HttpResponse)) {
        return {error: 'Unexpected error'};
    }

    return {url: response.content.data.url as string, ref: response.content.data.imageRef as string};
}
